<template>
  <article class="CardDadosPessoais w-100s">
    <form @submit.prevent="validar">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-12 mb-4">
              <strong style=" font-size: 1.3em; color: #707070;"
                >Seus dados</strong
              >
            </div>
            <div class="col-12 col-md-6 field">
              <input
                :class="{ error: errorForm && !msn.cliente.nome }"
                type="text"
                id="firstName"
                placeholder=" "
                v-model="form.cliente.nome"
                required
              />
              <label for="firstName">Nome completo</label>
            </div>
            <div class="col-12 col-md-6 field">
              <input
                type="tel"
                id="cpf"
                v-mask="'###.###.###-##'"
                placeholder=" "
                v-model="form.cliente.cpf"
                pattern=".{14}"
                title="000.000.000-00"
                required
              />
              <label for="cpf">CPF</label>
            </div>
            <div class="col-12 field">
              <input
                type="email"
                placeholder=" "
                id="form.cliente.email"
                v-model="form.cliente.email"
                required
              />
              <label for="form.cliente.email">E-mail</label>
            </div>
            <div class="col-12 col-md-5 field">
              <input
                :class="{ error: errorForm && !msn.cliente.celular }"
                type="tel"
                id="form.cliente.celular"
                placeholder=" "
                v-model="form.cliente.celular"
                v-mask="['(##) ####-####', '(##) #####-####']"
                pattern=".{14,15}"
                title="(00) 0000-0000"
                required
              />
              <label for="form.cliente.celular">Celular</label>
            </div>
            <div
              class="col-12 col-md-5 field calendar"
              :class="{
                notEmpty: form.cliente.dataNascimento,
                error: errorForm && !msn.cliente.nome
              }"
            >
              <input
                v-model="form.cliente.dataNascimento"
                placeholder=" "
                id="form.cliente.dataNascimento"
                format="DD/MM/YYYY"
                v-mask="'##/##/####'"
                required
                pattern=".{10}"
                @blur="validarData"
              />
              <label for="form.cliente.dataNascimento"
                >Data de Nascimento</label
              >
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-12 field">
              <strong style=" font-size: 1.3em; color: #707070;"
                >Endereço de entrega</strong
              >
            </div>
            <div class="col-12 col-md-4 field">
              <input
                type="text"
                id="form.enderecoEntrega.cep"
                placeholder=" "
                v-model="form.enderecoEntrega.cep"
                @blur="getCep($event, true)"
                v-mask="'#####-###'"
                pattern=".{9}"
                title="00000-000"
                required
              />
              <label for="form.enderecoEntrega.cep">
                CEP
                <div
                  class="spinner-border"
                  style="width: 1rem; height: 1rem;"
                  :class="{ 'd-none': !cepEntregaBuscando }"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </label>
              <small
                class="text-danger"
                style="position:absolute;bottom: -20px;"
                v-if="cepEntregaError"
              >
                <span v-if="!cepMsgError">*CEP não localizado</span>
                <span v-if="cepMsgError">{{ cepMsgError }}</span>
              </small>
            </div>
            <div class="col-12 col-md-4 field">
              <input
                :class="{ error: errorForm && !msn.enderecoEntrega.endereco }"
                type="text"
                id="form.enderecoEntrega.endereco"
                placeholder=" "
                v-model="form.enderecoEntrega.endereco"
                required
              />
              <label for="form.enderecoEntrega.endereco">Endereço</label>
            </div>
            <div class="col-12 col-md-4 field">
              <input
                type="text"
                id="form.enderecoEntrega.complemento"
                placeholder=" "
                v-model="form.enderecoEntrega.complemento"
              />
              <label for="form.enderecoEntrega.complemento">Complemento</label>
            </div>
            <div class="col-12 col-md-2 field">
              <input
                :class="{ error: errorForm && !msn.enderecoEntrega.numero }"
                type="text"
                id="form.enderecoEntrega.numero"
                placeholder=" "
                v-model="form.enderecoEntrega.numero"
                pattern=".{1,}"
                required
              />
              <label for="form.enderecoEntrega.numero">Número</label>
            </div>
            <div class="col-12 col-md-4 field">
              <input
                :class="{ error: errorForm && !msn.enderecoEntrega.bairro }"
                type="text"
                id="form.enderecoEntrega.bairro"
                placeholder=" "
                v-model="form.enderecoEntrega.bairro"
                required
              />
              <label for="form.enderecoEntrega.bairro">Bairro</label>
            </div>
            <div class="col-12 col-md-4 field">
              <input
                :class="{ error: errorForm && !msn.enderecoEntrega.cidade }"
                type="text"
                id="form.enderecoEntrega.cidade"
                placeholder=" "
                v-model="form.enderecoEntrega.cidade"
                required
              />
              <label for="form.enderecoEntrega.cidade">Cidade</label>
            </div>
            <div class="col-12 col-md-2 field">
              <select
                class="custom-select d-block w-100"
                id="form.enderecoEntrega.estado"
                :class="{ notEmpty: form.enderecoEntrega.estado }"
                required
                v-model="form.enderecoEntrega.estado"
              >
                <option>RO</option>
                <option>AC</option>
                <option>AM</option>
                <option>RR</option>
                <option>PA</option>
                <option>AP</option>
                <option>TO</option>
                <option>MA</option>
                <option>PI</option>
                <option>CE</option>
                <option>RN</option>
                <option>PB</option>
                <option>PE</option>
                <option>AL</option>
                <option>SE</option>
                <option>BA</option>
                <option>MG</option>
                <option>ES</option>
                <option>RJ</option>
                <option>SP</option>
                <option>PR</option>
                <option>SC</option>
                <option>RS</option>
                <option>MS</option>
                <option>MT</option>
                <option>GO</option>
                <option>DF</option>
              </select>
              <label for="form.enderecoEntrega.estado">Estado</label>
            </div>
          </div>
          <div class="row">
            <div class="col col-md-12 mb-4">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  v-model="form.enderecoIguais"
                  class="custom-control-input"
                  id="same-address"
                />
                <label class="custom-control-label" for="same-address"
                  >O endereço de entrega é igual ao meu endereço de
                  cobrança</label
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card mt-3" v-if="!form.enderecoIguais">
        <div class="card-body">
          <div class="row">
            <div class="col-12 mb-4">
              <strong style=" font-size: 1.3em; color: #707070;"
                >Endereço de cobrança</strong
              >
            </div>
            <div class="col-12 col-md-4 field">
              <input
                :class="{ error: errorForm && !msn.cliente.endereco.cep }"
                type="text"
                id="form.cliente.endereco.cep"
                placeholder=" "
                v-model="form.cliente.endereco.cep"
                @blur="getCep($event, false)"
                v-mask="'#####-###'"
                pattern=".{9}"
                title="00000-000"
                :required="!form.enderecoIguai"
              />
              <label for="form.cliente.endereco.cep">
                CEP
                <div
                  class="spinner-border"
                  style="width: 1rem; height: 1rem;"
                  :class="{ 'd-none': !cepBuscando }"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </label>
              <small
                class="text-danger"
                style="position:absolute;bottom: -20px;"
                v-if="cepError"
                >*CEP não localizado</small
              >
            </div>
            <div class="col-12 col-md-4 field">
              <input
                :class="{ error: errorForm && !msn.cliente.endereco.endereco }"
                type="text"
                id="form.cliente.endereco.endereco"
                placeholder=" "
                v-model="form.cliente.endereco.endereco"
                :required="!form.enderecoIguai"
              />
              <label for="form.cliente.endereco.endereco">Endereço</label>
            </div>
            <div class="col-12 col-md-4 field">
              <input
                type="text"
                id="form.cliente.endereco.complemento"
                placeholder=" "
                v-model="form.cliente.endereco.complemento"
              />
              <label for="form.cliente.endereco.complemento">Complemento</label>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-2 field">
              <input
                :class="{ error: errorForm && !msn.cliente.endereco.numero }"
                type="text"
                id="form.cliente.endereco.numero"
                placeholder=" "
                v-model="form.cliente.endereco.numero"
                pattern=".{1,}"
                :required="!form.enderecoIguai"
              />
              <label for="form.cliente.endereco.numero">Número</label>
            </div>
            <div class="col-12 col-md-4 field">
              <input
                :class="{ error: errorForm && !msn.cliente.endereco.bairro }"
                type="text"
                id="form.cliente.endereco.bairro"
                placeholder=" "
                v-model="form.cliente.endereco.bairro"
                :required="!form.enderecoIguai"
              />
              <label for="form.cliente.endereco.bairro">Bairro</label>
            </div>
            <div class="col-12 col-md-4 field">
              <input
                :class="{ error: errorForm && !msn.cliente.endereco.cidade }"
                type="text"
                id="form.cliente.endereco.cidade"
                placeholder=" "
                v-model="form.cliente.endereco.cidade"
                :required="!form.enderecoIguai"
              />
              <label for="form.cliente.endereco.cidade">Cidade</label>
            </div>
            <div class="col-12 col-md-2 field">
              <select
                class="custom-select d-block w-100"
                id="form.cliente.endereco.estado"
                :class="{ notEmpty: form.cliente.endereco.estado }"
                v-model="form.cliente.endereco.estado"
                :required="!form.enderecoIguai"
              >
                <option>RO</option>
                <option>AC</option>
                <option>AM</option>
                <option>RR</option>
                <option>PA</option>
                <option>AP</option>
                <option>TO</option>
                <option>MA</option>
                <option>PI</option>
                <option>CE</option>
                <option>RN</option>
                <option>PB</option>
                <option>PE</option>
                <option>AL</option>
                <option>SE</option>
                <option>BA</option>
                <option>MG</option>
                <option>ES</option>
                <option>RJ</option>
                <option>SP</option>
                <option>PR</option>
                <option>SC</option>
                <option>RS</option>
                <option>MS</option>
                <option>MT</option>
                <option>GO</option>
                <option>DF</option>
              </select>
              <label for="form.cliente.endereco.estado" class="">Estado</label>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="mostrarBotaoPagamento"
        class="mt-3 mb-5 row px-3 justify-content-between"
      >
        <router-link
          :to="{ path: `/loja` }"
          tag="button"
          class="btn btn-secondary px-5 mt-4 py-2"
        >
          VOLTAR
        </router-link>
        <button class="btn btn-primary py-2 px-5 mt-4" type="submit">
          CONTINUAR
        </button>
      </div>
    </form>
  </article>
</template>

<script>
import { APIService } from "../APIService";
const apiService = new APIService();

export default {
  name: "CardDadosPessoais",
  props: {},
  components: {},
  data() {
    return {
      mostrarBotaoPagamento: true,
      form: this.$store.state.dadosPessoais,
      msn: JSON.parse(JSON.stringify(this.$store.state.dadosPessoais)),
      errorForm: false,
      openDataNascimento: false,
      cepBuscando: false,
      cepError: true,
      cepEntregaBuscando: false,
      cepEntregaError: false,
      cepMsgError: ""
    };
  },
  created() {
    window.scrollTo(0, 0);
    this.$moment.locale("pt-br");
    // this.form.enderecoEntrega = JSON.parse(
    //   localStorage.getItem("endereco") || "{}"
    // );
  },
  methods: {
    getCep(event, enderecoEntrega) {
      const cep = event.target.value;
      if (cep.length == 9) {
        if (enderecoEntrega) {
          this.cepEntregaBuscando = true;
          this.cepEntregaError = false;
        } else {
          this.cepBuscando = true;
          this.cepError = false;
        }
        apiService
          .getCep(cep)
          .then(response => {
            this.cepMsgError = response.data.title;
            if (enderecoEntrega) {
              this.form.enderecoEntrega = response.data;
              this.cepEntregaBuscando = false;
            } else {
              this.form.cliente.endereco = response.data;
              this.cepBuscando = false;
            }
          })
          .catch(response => {
            if (enderecoEntrega) {
              this.cepEntregaError = true;
              this.cepEntregaBuscando = false;
            } else {
              this.cepError = true;
              this.cepBuscando = false;
              this.cepMsgError = response.data.title;
            }
          });
      }
    },
    realizarCheckout() {
      if (this.errorForm) {
        this.$store.dispatch("pedidoDadosPessoais", this.form).then(() => {
          this.goToStep("pedido");
        });
      }
    },
    validar() {
      this.errorForm = true;
      let errorField = false;
      if (this.form.enderecoIguais) {
        this.form.cliente.endereco = this.form.enderecoEntrega;
      }
      for (const key in this.form.cliente) {
        if (key == "endereco") {
          for (const keyEnd in this.form.cliente.endereco) {
            if (keyEnd !== "complemento") {
              this.msn.cliente.endereco[keyEnd] =
                (this.form.cliente.endereco[keyEnd] || "").trim().length > 0;
              if (!this.msn.cliente.endereco[keyEnd]) errorField = true;
            }
          }
        } else {
          this.msn.cliente[key] =
            (this.form.cliente[key] || "").trim().length > 0;
          if (!this.msn.cliente[key]) errorField = true;
        }
      }
      for (const key in this.form.enderecoEntrega) {
        if (key !== "complemento") {
          this.msn.enderecoEntrega[key] =
            (this.form.enderecoEntrega[key] || "").trim().length > 0;
          if (!this.msn.enderecoEntrega[key]) errorField = true;
        }
      }
      if (!errorField) this.realizarCheckout();
    },
    goToStep(step) {
      this.$emit("goToStep", step);
    },
    validarData() {
      if (
        !this.$moment(this.form.cliente.dataNascimento, "DD/MM/YYYY").isValid()
      )
        this.form.cliente.dataNascimento = "";
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.card {
  border-radius: 0 0 0.25rem 0.25rem;
}
</style>

<style lang="scss">
$color-blue: #0654ae;

.field {
  display: flex;
  flex-flow: column-reverse;
  margin-bottom: 1em;

  label,
  input:not([type="checkbox"]) {
    transition: all 0.2s;
    touch-action: manipulation;
  }

  input:not([type="checkbox"]) {
    border: none;
    border-bottom: 1px solid #ccc;
    -webkit-appearance: none;
    border-radius: 0;
    padding: 0.5em;
    cursor: text;
  }

  input:not([type="checkbox"]):focus {
    outline: 0;
    border-bottom: 1px solid #666;
  }

  label {
    letter-spacing: 0.05em;
    margin: 0;
    color: #888888;
  }

  input:not([type="checkbox"]):placeholder-shown + label,
  .mx-datepicker + label,
  select + label {
    cursor: text;
    max-width: 90%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    transform-origin: left bottom;
    transform: translate(0, 2.15rem) scale(1);
  }

  ::-webkit-input-placeholder {
    opacity: 0;
    transition: inherit;
  }

  input:not([type="checkbox"]):focus::-webkit-input-placeholder {
    opacity: 1;
  }

  input:not([type="checkbox"]):not(:placeholder-shown) + label,
  input:not([type="checkbox"]):focus + label,
  .notEmpty .mx-datepicker + label,
  select.notEmpty + label,
  select:focus + label {
    transform: translate(0, 0.5em) scale(1);
    cursor: pointer;
  }
}

.form-check {
  input {
    opacity: 0;
    &:checked + label:before {
      background-color: $color-blue;
      border-color: $color-blue;
    }
    &:checked + label:after {
      content: "\00AC";
      width: 20px;
      height: 20px;
      position: absolute;
      left: 0;
      top: 0.28em;
      -webkit-appearance: none;
      color: #fff;
      transform: rotate(135deg);
      font-size: 1.2rem;
    }
  }
  label {
    &:before {
      content: "";
      border: 2px solid #888;
      width: 20px;
      height: 20px;
      position: absolute;
      left: 0;
      top: 1px;
      -webkit-appearance: none;
    }
  }
}

select {
  border: none !important;
  border-bottom: 1px solid #ccc !important;
  border-radius: 0 !important;
  border-radius: 0 !important;
  padding: 0.5em 0 !important;
  height: 41px;
  background-color: transparent !important;
  z-index: 2;
  &:focus {
    outline: none !important;
    box-shadow: none !important;
  }
}
.mx-datepicker {
  z-index: 2;
  input.mx-input {
    border: none !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    border-bottom: 1px solid #ccc !important;
    height: 41px !important;
    background-color: transparent;
  }
}

.field.error input,
.error {
  border-color: red !important;
}
</style>
